import React, { useState, useEffect } from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { useSelector } from 'react-redux';
import HelmetComponent from '@/components/general/Helmet/HelmetComponent';
import Label from '@/components/form/Label/Label';
import './TermsAndConditions.scss';

const TermsAndConditions = (props) => {
  const lenguageData = useSelector((state) => state.lenguage.lang);
  const esDescription =
    'Al reservar en Popnest, aceptas nuestras normas de uso, pago y cancelación. Respetamos tu privacidad y te pedimos cuidar el espacio y a otros usuarios. Consulta nuestros términos para más detalles.';
  const enDescription =
    'By booking with Popnest, you agree to our usage, payment, and cancellation policies. We respect your privacy and ask you to care for the space and other users. Check our terms for more details.';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <FlexContainer className={'termsView flex-column margtb40 text-justify'}>
      <HelmetComponent
        title={
          lenguageData === 'EN'
            ? 'Terms and Conditions - Popnest'
            : 'Terminos y Condiciones - Popnest'
        }
        description={lenguageData === 'EN' ? enDescription : esDescription}
        graphTitle={
          lenguageData === 'EN'
            ? 'Terms and Conditions - Popnest'
            : 'Terminos y Condiciones - Popnest'
        }
        graphDescription={lenguageData === 'EN' ? enDescription : esDescription}
      />
      <Label className={'text-12 m-text-10'}>
        {lenguageData === 'EN' && (
          <>
            <div class="header">
              <h1>Terms of Service</h1>
              <p>Popnest</p>
              <p style={{ marginTop: '10px', fontSize: '0.95rem' }}>Last updated: December 22, 2025</p>
            </div>

            <div class="container">
              <div class="section">
                <p>
                  FINOVIX S.A.P.I. de C.V. (hereinafter POPNEST), with address in COYOACÁN, ÁLVARO
                  OBREGÓN hereby discloses the agreement describing the general Terms and Conditions
                  of use of its website (hereinafter, the "Page") and/or any other digital platform
                  it makes available to you, which may contain, by way of example but not
                  limitation, information, services, inquiries, content and/or products.
                  (hereinafter the "Services").
                </p>

                <p>
                  This contract describes the general terms and conditions (hereinafter only "TERMS
                  AND CONDITIONS") applicable to the use of the content, products and services
                  offered through the site https://www.popnest.org/ (hereinafter, "WEBSITE"), owned
                  by FINOVIX S.A.P.I. de C.V. (hereinafter, POPNEST). Anyone wishing to access or
                  use the site or the services offered may do so subject to these TERMS AND
                  CONDITIONS, as well as policies and principles incorporated into this document.
                </p>

                <div class="highlight-box">
                  <p>
                    In any case, any person who does not accept these terms and conditions must
                    refrain from using the WEBSITE and/or acquiring the products and services that
                    may be offered.
                  </p>
                </div>
              </div>

              <div class="section">
                <h2>I. OBJECT</h2>
                <p>
                  The purpose of these TERMS AND CONDITIONS is to regulate access to and use of the
                  WEBSITE, understood as any type of content, product or service available to the
                  general public within the domain: https://www.popnest.org/
                </p>

                <p>
                  POPNEST reserves the right to modify at any time and without prior notice, the
                  presentation, content, functionality, products and services that may be contained
                  in the WEBSITE; in this sense, the USER acknowledges and accepts that POPNEST may
                  at any time interrupt, deactivate or cancel any of the elements that make up the
                  WEBSITE or access to them.
                </p>

                <p>
                  Supplementary conditions may apply to certain Services, such as policies for a
                  particular activity or promotion, and such supplementary conditions will be
                  communicated in relation to the applicable Services. Supplementary conditions are
                  established in addition to the Terms and Conditions, and will be considered part
                  of them, for the purposes of the applicable Services. Supplementary conditions
                  will prevail over the Conditions in case of conflict with respect to the
                  applicable Services.
                </p>

                <p>
                  Access to the WEBSITE by the USER is free and, as a general rule, is free without
                  the USER having to provide consideration to enjoy it, except with respect to the
                  cost of the internet connection supplied by the provider of this type of service
                  that the USER has contracted.
                </p>

                <p>
                  The WEBSITE is directed exclusively to persons who have reached the age of
                  majority (over 18 years of age); in this sense, POPNEST disclaims any
                  responsibility for non-compliance with this requirement.
                </p>

                <p>
                  The WEBSITE is directed primarily to USERS residing in the Mexican Republic,
                  therefore, POPNEST does not guarantee that the WEBSITE fully or partially complies
                  with the legislation of other countries, so that if the USER resides or has their
                  domicile established in another country and decides to access or use the WEBSITE,
                  they will do so at their own risk and must ensure that such access and navigation
                  complies with the local legislation applicable to them, POPNEST assuming no
                  responsibility that may arise from such act.
                </p>

                <p>
                  It is made known to the USER that POPNEST may administer or manage the WEBSITE
                  directly or through a third party, which does not modify in any way what is
                  established in these TERMS AND CONDITIONS.
                </p>
              </div>

              <div class="section">
                <h2>II. USER</h2>
                <p>
                  Access to or use of the WEBSITE, as well as the resources enabled to interact
                  between USERS, or between the USER and POPNEST such as means to make publications
                  or comments, confers the status of USER of the WEBSITE, and will be subject to
                  these TERMS AND CONDITIONS, as well as their subsequent modifications, without
                  prejudice to the application of applicable legislation, therefore, they will be
                  deemed accepted from the moment the WEBSITE is accessed. Given the relevance of
                  the above, the USER is recommended to review the updates made to these TERMS AND
                  CONDITIONS.
                </p>

                <p>
                  It is the USER's responsibility to use the WEBSITE in accordance with the way it
                  was designed; in this sense, the use of any type of software that automates the
                  interaction or download of content or services provided through the WEBSITE is
                  prohibited.
                </p>

                <p>
                  In addition, the USER undertakes to use the information, content or services
                  offered through the WEBSITE in a lawful manner, without contravening the
                  provisions of these TERMS AND CONDITIONS, morality or public order, and will
                  refrain from performing any act that may affect the rights of third parties, or
                  harm in any way the functioning of the WEBSITE.
                </p>

                <p>
                  Likewise, the USER undertakes to provide lawful and truthful information in the
                  forms enabled on the WEBSITE, in which the USER must provide certain data or
                  information to access any content, product or service offered by the WEBSITE
                  itself. In any case, the USER will immediately notify POPNEST of any fact that may
                  suggest the misuse of information registered in such forms, such as theft, loss,
                  or unauthorized access to accounts and/or passwords, in order to proceed with
                  their immediate cancellation.
                </p>

                <p>
                  Subject to compliance with these TERMS AND CONDITIONS, Clients and/or USERS
                  create, with their email, a personal, exclusive and non-transferable USER account
                  to carry out the purchase processes of products or acquisition of the Page.
                  POPNEST reserves any right that has not been expressly granted by these TERMS AND
                  CONDITIONS.
                </p>

                <p>
                  The use of the USER Account is personal and non-transferable, therefore Clients
                  and/or USERS are not authorized to transfer validation data to access their
                  profile. In case of forgetting validation data or usurpation of these, it is the
                  USER's obligation to inform POPNEST by sending an email to the account
                  info@popnest.org
                </p>

                <p>
                  Likewise, the USER accepts the privacy notice and terms and conditions of the
                  WEBSITE, when contacting POPNEST through electronic means, such as telephone call,
                  WhatsApp or email.
                </p>

                <p>
                  It is the entire responsibility of the USER to maintain confidentially and in a
                  safe place their USER and password to access their profile on the POPNEST portal,
                  therefore, through this instrument, the USER releases POPNEST from any
                  responsibility for any loss or damage, regardless of its scope or nature,
                  resulting from unauthorized access to the Client's or USER's profile.
                </p>

                <div class="accent-box">
                  <p>
                    <strong>
                      Without prejudice to other measures, POPNEST may warn, temporarily suspend or
                      permanently disable a USER's Account or publication, apply a sanction that
                      negatively impacts a USER's reputation, initiate actions it deems appropriate
                      and/or suspend the provision of its Services if:
                    </strong>
                  </p>
                  <ul>
                    <li>
                      (a) any law is violated, or any of the stipulations of the General Terms and
                      Conditions and other POPNEST policies
                    </li>
                    <li>(b) if it fails to fulfill its commitments as a USER</li>
                    <li>
                      (c) if POPNEST considers that fraudulent or malicious conduct or acts are
                      incurred
                    </li>
                    <li>
                      (d) the identity of the USER cannot be verified or any information provided by
                      them is erroneous
                    </li>
                    <li>
                      (e) POPNEST understands that publications or other actions may be a cause of
                      liability for the USER who published them
                    </li>
                  </ul>
                </div>

                <p>
                  POPNEST reserves the right to remove all comments and contributions that violate
                  the law, respect for human dignity, that are discriminatory, and/or violate the
                  rights of third parties or public order, or that in its judgment are not suitable
                  for publication.
                </p>

                <p>
                  In any case, POPNEST will not be responsible for the opinions expressed by USERS
                  through comments or publications they make.
                </p>

                <p>
                  Merely accessing the WEBSITE does not imply the establishment of any type of
                  relationship between POPNEST and the USER.
                </p>

                <p>
                  As it is a WEBSITE directed exclusively to persons who have reached the age of
                  majority, the USER declares to be of legal age and to have the legal capacity
                  necessary to be subject to these TERMS AND CONDITIONS.
                </p>
              </div>

              <div class="section">
                <h2>III. ACCESS AND NAVIGATION ON THE WEBSITE</h2>
                <p>
                  POPNEST does not guarantee in any way the continuity and availability of the
                  content, products or services offered through the WEBSITE, however, POPNEST will
                  carry out actions that according to its possibilities allow it to maintain the
                  proper functioning of the WEBSITE, without this implying any responsibility on the
                  part of POPNEST
                </p>

                <p>
                  Likewise, POPNEST will not be responsible or guarantee that the content or
                  software that may be accessed through the WEBSITE is free of errors, malicious
                  software, or that may cause any damage at the software or hardware level on the
                  equipment through which the USER accesses the WEBSITE.
                </p>

                <p>
                  POPNEST is also not responsible for damages that may be caused by improper use of
                  the WEBSITE. In no case will POPNEST be responsible for losses, damages or losses
                  of any kind that arise from merely accessing or using the WEBSITE.
                </p>
              </div>

              <div class="section">
                <h2>IV. PRIVACY POLICY AND DATA PROTECTION</h2>
                <p>
                  In accordance with the provisions of the Federal Law on Protection of Personal
                  Data Held by Private Parties, POPNEST undertakes to adopt the necessary measures
                  within its reach to ensure the privacy of personal data collected so that its
                  security is guaranteed, its alteration, loss or unauthorized processing is
                  prevented.
                </p>

                <p>
                  In addition, in order to comply with the provisions of the Federal Law on
                  Protection of Personal Data Held by Private Parties, any personal data collected
                  through the WEBSITE will be processed in accordance with the principles of
                  lawfulness, quality, purpose, loyalty, and responsibility. All processing of
                  personal data will be subject to POPNEST's consent.
                </p>

                <p>
                  In any case, the use of financial or patrimonial data will require express
                  authorization from POPNEST (and/or its subsidiaries or associated entities),
                  however, this may be given through the WEBSITE itself using the mechanisms enabled
                  for this purpose, and in any case the greatest diligence and care will be given to
                  this type of data. The same will occur in the case of sensitive personal data,
                  considering those that due to improper use may give rise to discrimination or
                  their disclosure entails a risk for POPNEST
                </p>

                <p>
                  At all times it will be ensured that the personal data contained in the databases
                  or files that may be used are relevant, correct and updated for the purposes for
                  which they were collected.
                </p>

                <p>
                  The processing of personal data will be limited to compliance with the purposes
                  provided for in the Privacy Notice which will be available at the following
                  electronic address:{' '}
                  <a href="https://www.popnest.org/privacy-policy" target="_blank">
                    https://www.popnest.org/privacy-policy
                  </a>
                </p>

                <p>
                  The WEBSITE may include hyperlinks or links that allow access to third-party
                  websites other than POPNEST. Such websites will have their own privacy and data
                  protection policies, therefore POPNEST does not assume any responsibility for data
                  that may be provided by the USER through any WEBSITE other than POPNEST
                </p>

                <p>
                  Personal data collected during purchase will be processed according to POPNEST's
                  Privacy Policy. Likewise, POPNEST is not responsible for the use of the USER's
                  personal data by courier companies and payment platforms, as they are entities
                  separate from POPNEST
                </p>

                <p>
                  POPNEST reserves the right to modify its Privacy Policy, according to its needs or
                  as a result of any change in legislation. Access or use of the WEBSITE after such
                  changes will imply acceptance of these changes.
                </p>

                <p>
                  On the other hand, access to the WEBSITE may involve the use of cookies, which are
                  small amounts of information stored in the browser used by the USER. Cookies
                  facilitate navigation, make it more user-friendly, and do not damage the
                  navigation device. For this purpose, they may collect information to enter the
                  WEBSITE, store USER preferences, as well as the interaction they have with the
                  WEBSITE, such as: the date and time when the WEBSITE is accessed, the time it has
                  been used, the sites visited before and after it, the number of pages visited, the
                  IP address from which the USER accesses, the frequency of visits, etc.
                </p>

                <p>
                  This type of information will be used to improve the WEBSITE, detect errors, and
                  possible needs that the USER may have, the above in order to offer USERS better
                  quality services and content. In any case, the information collected will be
                  anonymous and will not identify individual USERS.
                </p>

                <p>
                  If the USER does not want this type of information to be collected, they must
                  disable, reject, restrict and/or delete the use of cookies in their internet
                  browser. The procedures to perform these actions may differ from one browser to
                  another; consequently, it is suggested to review the instructions provided by the
                  browser developer. If the use of cookies is rejected (totally or partially), the
                  USER may continue using the WEBSITE, although some of its functions may be
                  disabled.
                </p>

                <p>
                  It is possible that in the future these policies regarding cookies may change or
                  be updated, therefore it is recommended to review the updates made to these TERMS
                  AND CONDITIONS, in order to be adequately informed about how and for what we use
                  the cookies generated when entering or using the WEBSITE.
                </p>
              </div>

              <div class="section">
                <h2>V. LINK POLICY</h2>
                <p>
                  The WEBSITE may contain links, content, services or functions from other internet
                  sites belonging to and/or managed by third parties, such as images, videos,
                  comments, search engines, etc.
                </p>

                <p>
                  The use of these links, content, services or functions is intended to improve the
                  USER's experience when using the WEBSITE, without it being considered a
                  suggestion, recommendation or invitation to use external sites. POPNEST will in no
                  case review or control the content of external sites, likewise, it does not make
                  its own the products, services, content, and any other material existing on the
                  linked sites; therefore, the availability, accuracy, veracity, validity or
                  legality of external sites that may be accessed through the WEBSITE will not be
                  guaranteed. Likewise, POPNEST does not assume any responsibility for damages that
                  may be caused by access or use of the content, products or services available on
                  websites not managed by POPNEST that may be accessed through the WEBSITE.
                </p>

                <p>
                  USERS or third parties who make or publish a web link from an external website to
                  this WEBSITE must take into account the following:
                </p>

                <p>
                  Reproduction (total or partial) of the content, products or services available on
                  the WEBSITE is not permitted without the express authorization of POPNEST. False,
                  inaccurate or incorrect statements about the WEBSITE, or about its content,
                  products or services will also not be permitted, POPNEST may restrict access to
                  the WEBSITE to any person who incurs in this type of act.
                </p>

                <p>
                  The establishment of a link to the WEBSITE from any external site does not imply
                  the existence of any relationship between POPNEST and the WEBSITE from which it is
                  made, nor does it imply POPNEST's knowledge of the content, products or services
                  offered on the external sites from which the WEBSITE may be accessed.
                </p>
              </div>

              <div class="section">
                <h2>VI. INTELLECTUAL AND INDUSTRIAL PROPERTY POLICY</h2>
                <p>
                  POPNEST, by itself or as assignee, is the owner of all intellectual and industrial
                  property rights of the WEBSITE, understood as the source code that makes its
                  operation possible, as well as images, audio or video files, structures, designs
                  and other elements that distinguish it. They will therefore be protected by
                  Mexican legislation on intellectual and industrial property, as well as applicable
                  international treaties. Consequently, the reproduction, distribution, or
                  dissemination of the contents of the WEBSITE for commercial purposes, on any
                  medium and by any means, without the authorization of POPNEST is expressly
                  prohibited.
                </p>

                <p>
                  The USER undertakes to respect POPNEST's intellectual and industrial property
                  rights, however, in addition to being able to view the elements of the WEBSITE,
                  they may print them, copy them or store them, as long as it is exclusively for
                  their strictly personal use.
                </p>

                <p>
                  On the other hand, the USER will refrain from deleting, altering, or manipulating
                  any element, file, or content of the WEBSITE, and will under no circumstances
                  perform acts tending to violate the security, files or databases that are
                  protected, either through restricted access by means of a USER and password, or
                  because they do not have permission to view, edit or manipulate them.
                </p>

                <p>
                  In the event that the USER or any third party considers that any of the contents
                  of the WEBSITE constitutes a violation of industrial or intellectual property
                  protection rights, they must immediately communicate it through the contact
                  information available on the WEBSITE itself.
                </p>
              </div>

              <div class="section">
                <h2>VII. ELECTRONIC COMMUNICATIONS</h2>
                <p>
                  The USER accepts receiving electronic communications through WhatsApp, e-mail and
                  instant messaging through the WEBSITE from POPNEST. Notices will be disseminated
                  through: email; WhatsApp and by placing notices on the Web Page.
                </p>
                <p>The USER accepts that disclosures sent by email satisfy legal requirements.</p>
              </div>

              <div class="section">
                <h2>VIII. SPECIAL PROMOTIONS</h2>
                <p>
                  POPNEST may launch special promotions through which different benefits may be
                  offered to its USERS. Participation and acceptance of these promotions will
                  correspond to criteria determined exclusively by us. POPNEST does not commit to
                  launching special promotions on specific dates or derived from any eventuality at
                  any time.
                </p>

                <p>
                  The terms and conditions of special promotions that POPNEST offers will be
                  communicated when the promotion is published, its validity, and will be subject to
                  these terms and conditions and applicable Mexican laws on the matter.
                </p>
              </div>

              <div class="section">
                <h2>IX. CONSENT</h2>
                <p>
                  The USER states that the contractual relationship that may be generated by the use
                  of the Page or any of the Products offered will be directly with POPNEST and will
                  consist of a service provision entered into by electronic means, in which the
                  Client is the accredited party and POPNEST is the accrediting party.
                </p>

                <p>
                  By virtue of the legal capacity conditions established in current Mexican
                  legislation and the validity of the express manifestation of will through
                  electronic means established in articles 89 and 90 of the Commercial Code, as a
                  USER at the time of creating your Account, you expressly state your consent and
                  have sufficient capacity to enter into contracts that may or may be entered into
                  by accessing and using the Page or POPNEST Products. In this sense, acceptance of
                  these Terms and Conditions, as well as the respective adhesion contracts for each
                  Product, is the means by which you express your express consent to be subject to
                  them.
                </p>

                <p>
                  Additionally, the USER accepts and acknowledges that the manifestation of consent
                  regarding the Services contracted through the WEBSITE, as well as the
                  authorizations to POPNEST necessary for their contracting, may be through
                  electronic means such as telephone call, WhatsApp, or email.
                </p>
              </div>

              <div class="section">
                <h2>X. RESERVATION AND SPACE AVAILABILITY</h2>
                <p>
                  The USER may make the reservation in accordance with the availability of the space
                  and the established conditions which include both the maximum number of people to
                  enter and the minimum contracting of hours or days.
                </p>

                <p>
                  POPNEST through its WEBSITE offers a variety of spaces providing information about
                  their location, offering images that contain a visual representation of each
                  property, although it is noted that such images may present variations in terms of
                  color and lighting may vary in terms of color or lighting.
                </p>

                <p>
                  Detailed information about the property is provided once the USER expresses
                  interest in reserving or making the corresponding payment. In this way, access is
                  obtained to specific details about the space, such as outstanding features,
                  amenities and any relevant information for their stay. This optimizes the USER's
                  experience to make an informed decision, which guarantees that the information
                  provided by POPNEST is updated, providing confidence to the USER when making their
                  reservation.
                </p>

                <p>
                  POPNEST guarantees a transparent reservation experience by providing complete,
                  real information about the conditions and restrictions for each space, allowing
                  the USER to make informed decisions when making their reservation.
                </p>
              </div>

              <div class="section">
                <h2>XI. RESERVATION CHANGE</h2>
                <p>
                  The USER has the possibility to change their reservation once the corresponding
                  total payment is reflected, for a space of equal or higher price, as long as they
                  make the change request with at least 15 natural days in advance of the
                  reservation date. Likewise, any change will be subject to existing availability at
                  that time.
                </p>

                <p>
                  The USER undertakes to pay any additional amount, commission or tax that is linked
                  to the modification.
                </p>
              </div>

              <div class="section">
                <h2>XII. RESERVATION MODIFICATION</h2>
                <p>
                  The USER may carry out the modification of their itinerary to extend the duration
                  of stay in the same space or modify the entry date, once the corresponding total
                  payment is reflected, as long as such request is made with at least 15 natural
                  days in advance of the reservation date. Such modification will be subject to the
                  availability of dates of the space.
                </p>

                <p>
                  If the USER wishes to extend the duration of their stay and add hours or days to
                  their existing reservation, they must contact POPNEST during their stay. In this
                  way, the process will be facilitated to carry out the corresponding payment and
                  guarantee the continuity of the reservation, which will be subject to the
                  availability of the space. Likewise, the USER undertakes to pay any additional
                  amount, commission or tax that is linked to the modification.
                </p>

                <p>
                  In case the USER requires extending their stay after having concluded their
                  initial reservation, they must make a new reservation.
                </p>

                <p>
                  POPNEST provides flexibility to the USER during their stay, so they may make
                  modifications or adjustments to reservations in accordance with availability and
                  established policies.
                </p>
              </div>

              <div class="section">
                <h2>XIII. RESERVATION CANCELLATION AND REFUND</h2>
                <p>
                  The USER may carry out the cancellation of their reservation once the
                  corresponding total payment is reflected and will receive a refund in accordance
                  with the following:
                </p>

                <ol>
                  <li>
                    To receive 90% refund of the amount paid for space reservation, the USER must
                    cancel with 30 natural days in advance of the accommodation start date.
                  </li>
                  <li>
                    To receive 70% refund of the amount paid for space reservation, the USER must
                    make the cancellation with an advance of 29 to 15 natural days prior to the
                    scheduled date for the start of accommodation.
                  </li>
                  <li>
                    To receive 50% refund of the amount paid for space reservation, the USER must
                    make the cancellation with an advance of 14 to 10 natural days prior to the
                    scheduled date for the start of accommodation.
                  </li>
                  <li>
                    The refund policy will be void if the USER requests cancellation within a period
                    of 9 natural days and up to 24 hours before the accommodation start date.
                  </li>
                </ol>

                <table>
                  <thead>
                    <tr>
                      <th>DAYS IN ADVANCE TO RESERVATION DATE</th>
                      <th>REFUND PERCENTAGE</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Up to 30 natural days</td>
                      <td>90%</td>
                    </tr>
                    <tr>
                      <td>From 29 to 15 natural days</td>
                      <td>70%</td>
                    </tr>
                    <tr>
                      <td>From 14 to 10 natural days</td>
                      <td>50%</td>
                    </tr>
                    <tr>
                      <td>9 natural days or less</td>
                      <td>No refund applies</td>
                    </tr>
                  </tbody>
                </table>

                <p>
                  "Day 0" is understood as the day on which the USER uses the space. And "day 1" is
                  understood as the day prior to the start of accommodation.
                </p>

                <p>
                  In case the stay cannot be carried out due to force majeure or fortuitous
                  circumstances, the USER has various options to manage their reservation. (i) The
                  USER may choose to request a refund of the corresponding amount, (ii) reschedule
                  the stay for another date as long as the availability of the space is taken into
                  consideration and (iii) may make the change of reservation for another space of
                  the same cost.
                </p>

                <p>
                  POPNEST undertakes to offer flexibility in case rescheduling or space change are
                  viable, guaranteeing a reservation experience that adjusts to the USER's
                  preferences and needs.
                </p>
              </div>

              <div class="section">
                <h2>XIV. USER RESPONSIBILITY POLICY</h2>
                <p>
                  The USER assumes responsibility for their actions and omissions within the space,
                  provided by the Host. Therefore the USER:
                </p>
                <ul>
                  <li>(i) must occupy and vacate the space at the agreed time</li>
                  <li>
                    (ii) has the responsibility to leave the space in the same state in which it was
                    at the time of their arrival
                  </li>
                  <li>
                    (iii) it is the USER's responsibility to cover the amounts of claims for damages
                    to compensate for the damages caused by the USER, guests or pets to a space
                  </li>
                  <li>
                    (iv) the USER is obliged to maintain behavior with integrity, complying with
                    applicable laws at all times
                  </li>
                </ul>
              </div>

              <div class="section">
                <h2>XV. PAYMENT</h2>
                <p>
                  The WEBSITE uses a payment system operated by STRIPE Payments in which the USER
                  can choose from the following payment methods the one that is most convenient:
                </p>
                <ul>
                  <li>(i) ApplePay</li>
                  <li>(ii) Oxxo (by means of a payment reference)</li>
                  <li>
                    (iii) Debit and credit card with payment processors Visa, MasterCard and
                    American Express
                  </li>
                </ul>
              </div>

              <div class="section">
                <h2>XVI. DOUBTS, CLAIMS OR CLARIFICATIONS</h2>
                <p>
                  The USER can issue doubts, claims or clarifications to POPNEST through email:{' '}
                  <a href="mailto:info@popnest.org">info@popnest.org</a>
                </p>
              </div>

              <div class="section">
                <h2>XVII. CUSTOMER SERVICE</h2>
                <p>
                  POPNEST makes available to the USER the email{' '}
                  <a href="mailto:info@popnest.org">info@popnest.org</a> through which they can
                  communicate with the Customer Service area, in which any question related to the
                  use of the WEBSITE or the purchase of products can be resolved.
                </p>
              </div>

              <div class="section">
                <h2>XVIII. DAMAGES</h2>
                <p>
                  POPNEST is not responsible for any damage that occurs in the space contracted by
                  the USER. The USER assumes all responsibility for the use of the contracted space,
                  including the adequate conservation of the facilities, the security of personal
                  objects and general conduct during their stay, the USER exempts POPNEST from any
                  responsibility related to incidents or accidents that may arise during the period
                  of use of the contracted space
                </p>

                <p>
                  The agreements made between the USER and the Host develop independently of
                  POPNEST's participation. Therefore POPNEST does not assume responsibility for
                  possible breaches in the agreements established between the USER and the Host; any
                  dispute or disagreement derived from such interaction does not involve POPNEST.
                </p>
              </div>

              <div class="section">
                <h2>XIX. APPLICABLE LEGISLATION AND JURISDICTION</h2>
                <p>
                  POPNEST reserves the right to all actions and/or rights it deems necessary against
                  the USER for improper use of the WEBSITE, its content, products or services, or
                  for non-compliance with these TERMS AND CONDITIONS.
                </p>

                <p>
                  The relationship between the USER and POPNEST will be governed by the legislation
                  in force in Mexico, specifically in Mexico City. If disputes arise related to the
                  interpretation and/or application of these TERMS AND CONDITIONS, the parties will
                  submit to the ordinary jurisdiction of the corresponding courts in accordance with
                  the law in the referred state.
                </p>
              </div>

              <div class="contact-info">
                <h4>Contact</h4>
                <p>
                  <strong>POPNEST</strong>
                </p>
                <p>
                  <strong>FINOVIX, S.A.P.I. de C.V.</strong>
                </p>
                <p>Address: COYOACÁN, ÁLVARO OBREGÓN</p>
                <p>
                  Email: <a href="mailto:info@popnest.org">info@popnest.org</a>
                </p>
                <p>
                  Website:{' '}
                  <a href="https://popnest.org" target="_blank">
                    popnest.org
                  </a>
                </p>
              </div>
            </div>

            <footer>
              <p class="contact-info">Questions or Clarifications: info@popnest.org</p>
            </footer>
          </>
        )}
        {lenguageData === 'ES' && (
          <>
            <div class="header">
              <h1>Términos y Condiciones Usuario</h1>
              <p>Popnest</p>
              <p style={{ marginTop: '10px', fontSize: '0.95rem' }}>
                Última actualización: 22 de diciembre del 2025
              </p>
            </div>

            <div class="container">
              <div class="section">
                <p>
                  FINOVIX S.A.P.I. de C.V. (en lo sucesivo POPNEST), con domicilio en COYOACÁN,
                  ÁLVARO OBREGÓN da a conocer por este medio el convenio donde se describen los
                  Términos y Condiciones generales de uso de su página web (en adelante, la
                  "Página") y/o cualquier otra plataforma digital que exponga a tu disposición, en
                  las cuales se pueden encontrar en forma enunciativa más no limitativa,
                  información, servicios, consultas, contenidos y/o productos. (en adelante los
                  "Servicios").
                </p>

                <p>
                  Este contrato describe los términos y condiciones generales (en adelante
                  únicamente "TÉRMINOS Y CONDICIONES") aplicables al uso de los contenidos,
                  productos y servicios ofrecidos a través del sitio https://www.popnest.org/ (en
                  adelante, "SITIO WEB"), del cual es titular FINOVIX S.A.P.I. de C.V. (en adelante,
                  POPNEST) Quien desee acceder o usar el sitio o los servicios ofrecidos, podrá
                  hacerlo sujetándose a los presentes TÉRMINOS Y CONDICIONES, así como a políticas y
                  principios incorporados a este documento.
                </p>

                <div class="highlight-box">
                  <p>
                    En todo caso, cualquier persona que no acepte los presentes términos y
                    condiciones, deberá abstenerse de utilizar el SITIO WEB y/o adquirir los
                    productos y servicios que en su caso sean ofrecidos.
                  </p>
                </div>
              </div>

              <div class="section">
                <h2>I. DEL OBJETO</h2>
                <p>
                  El objeto de los presentes TÉRMINOS Y CONDICIONES es regular el acceso y la
                  utilización del SITIO WEB, entendiendo por éste cualquier tipo de contenido,
                  producto o servicio que se encuentre a disposición del público en general dentro
                  del dominio: https://www.popnest.org/
                </p>

                <p>
                  POPNEST se reserva la facultad de modificar en cualquier momento y sin previo
                  aviso, la presentación, los contenidos, la funcionalidad, los productos y los
                  servicios, que pudieran estar contenidos en el SITIO WEB; en este sentido, el
                  USUARIO reconoce y acepta que POPNEST en cualquier momento podrá interrumpir,
                  desactivar o cancelar cualquiera de los elementos que conforman el SITIO WEB o el
                  acceso a los mismos.
                </p>

                <p>
                  Se podrán aplicar condiciones suplementarias a determinados Servicios, como
                  políticas para una actividad o una promoción particular, y dichas condiciones
                  suplementarias se comunicarán en relación con los Servicios aplicables. Las
                  condiciones suplementarias se establecen además de los Términos y Condiciones, y
                  se considerarán una parte más de éstas, para los fines de los Servicios
                  aplicables. Las condiciones suplementarias prevalecerán sobre las Condiciones en
                  el caso de conflicto con respecto a los Servicios aplicables.
                </p>

                <p>
                  El acceso al SITIO WEB por parte del USUARIO tiene carácter libre y, por regla
                  general es gratuito sin que el USUARIO tenga que proporcionar una contraprestación
                  para poder disfrutar de ello, salvo en lo referente al costo de la conexión a
                  internet suministrada por el proveedor de este tipo de servicios que hubiere
                  contratado el mismo USUARIO.
                </p>

                <p>
                  El SITIO WEB se encuentra dirigido exclusivamente a personas que cuenten con la
                  mayoría de edad (mayores de 18 años); en este sentido, POPNEST declina cualquier
                  responsabilidad por el incumplimiento de este requisito.
                </p>

                <p>
                  El SITIO WEB está dirigido principalmente a USUARIOS residentes en la República
                  Mexicana, por lo cual, POPNEST no asegura que el SITIO WEB cumpla total o
                  parcialmente con la legislación de otros países, de forma que, si el USUARIO
                  reside o tiene su domicilio establecido en otro país y decide acceder o utilizar
                  el SITIO WEB lo hará bajo su propia responsabilidad y deberá asegurarse de que tal
                  acceso y navegación cumple con la legislación local que le es aplicable, no
                  asumiendo POPNEST ninguna responsabilidad que se pueda derivar de dicho acto.
                </p>

                <p>
                  Se hace del conocimiento del USUARIO que POPNEST podrá administrar o gestionar el
                  SITIO WEB de manera directa o a través de un tercero, lo cual no modifica en
                  ningún sentido lo establecido en los presentes TÉRMINOS Y CONDICIONES.
                </p>
              </div>

              <div class="section">
                <h2>II. DEL USUARIO</h2>
                <p>
                  El acceso o utilización del SITIO WEB, así como de los recursos habilitados para
                  interactuar entre los USUARIOS, o entre el USUARIO y POPNEST tales como medios
                  para realizar publicaciones o comentarios, confiere la condición de USUARIO del
                  SITIO WEB, por lo que quedará sujeto a los presentes TÉRMINOS Y CONDICIONES, así
                  como a sus ulteriores modificaciones, sin perjuicio de la aplicación de la
                  legislación aplicable, por tanto, se tendrán por aceptados desde el momento en el
                  que se accede al SITIO WEB. Dada la relevancia de lo anterior, se recomienda al
                  USUARIO revisar las actualizaciones que se realicen a los presentes TÉRMINOS Y
                  CONDICIONES.
                </p>

                <p>
                  Es responsabilidad del USUARIO utilizar el SITIO WEB de acuerdo con la forma en la
                  que fue diseñado; en este sentido, queda prohibida la utilización de cualquier
                  tipo de software que automatice la interacción o descarga de los contenidos o
                  servicios proporcionados a través del SITIO WEB.
                </p>

                <p>
                  Además, el USUARIO se compromete a utilizar la información, contenidos o servicios
                  ofrecidos a través del SITIO WEB de manera lícita, sin contravenir lo dispuesto en
                  los presentes TÉRMINOS Y CONDICIONES, la moral o el orden público, y se abstendrá
                  de realizar cualquier acto que pueda suponer una afectación a los derechos de
                  terceros, o perjudique de algún modo el funcionamiento del SITIO WEB.
                </p>

                <p>
                  Así mismo, el USUARIO se compromete a proporcionar información lícita y veraz en
                  los formularios habilitados en el SITIO WEB, en los cuales el USUARIO tenga que
                  proporcionar ciertos datos o información para el acceso a algún contenido,
                  producto o servicio ofrecido por el propio SITIO WEB. En todo caso, el USUARIO
                  notificará de forma inmediata a POPNEST acerca de cualquier hecho que permita
                  suponer el uso indebido de la información registrada en dichos formularios, tales
                  como, robo, extravío, o acceso no autorizado a cuentas y/o contraseñas, con el fin
                  de proceder a su inmediata cancelación.
                </p>

                <p>
                  Sujeto al cumplimiento de los presentes TÉRMINOS Y CONDICIONES, los Clientes y/o
                  USUARIOS crean, con su correo electrónico, una cuenta de USUARIO personal,
                  exclusiva e intransferible para realizar los procesos de compra de productos o de
                  adquisición de la Página. POPNEST se reserva cualquier derecho que no haya sido
                  expresamente otorgado por los presentes TÉRMINOS Y CONDICIONES.
                </p>

                <p>
                  El uso de la Cuenta de USUARIO es personal e intransferible, por lo cual los
                  Clientes y/o USUARIOS no se encuentran facultados para ceder los datos de
                  validación para el acceso a su perfil. En caso de olvido de los datos de
                  validación o de usurpación de éstos, es obligación del USUARIO informar a POPNEST
                  mediante el envío de un correo electrónico a la cuenta de info@popnest.org
                </p>

                <p>
                  De igual manera, el USUARIO acepta el aviso de privacidad y términos y condiciones
                  del SITIO WEB, al ponerse en contacto con POPNEST a través de medios electrónicos,
                  como llamada telefónica, WhatsApp o correo electrónico.
                </p>

                <p>
                  Es de la entera responsabilidad del USUARIO mantener de forma confidencial y en un
                  lugar seguro su USUARIO y contraseña para acceder a su perfil en el portal de
                  POPNEST por lo que, mediante el presente instrumento, el USUARIO deslinda a
                  POPNEST de toda responsabilidad por la pérdida o daño alguno, sin importar su
                  alcance o naturaleza, que resulte del acceso no autorizado al perfil del Cliente o
                  USUARIO.
                </p>

                <div class="accent-box">
                  <p>
                    <strong>
                      Sin perjuicio de otras medidas, POPNEST podrá advertir, suspender en forma
                      temporal o inhabilitar definitivamente la Cuenta de un USUARIO o una
                      publicación, aplicar una sanción que impacte negativamente en la reputación de
                      un USUARIO, iniciar las acciones que estime pertinentes y/o suspender la
                      prestación de sus Servicios si:
                    </strong>
                  </p>
                  <ul>
                    <li>
                      (a) se quebrantara alguna ley, o cualquiera de las estipulaciones de los
                      Términos y Condiciones Generales y demás políticas de POPNEST
                    </li>
                    <li>(b) si incumpliera sus compromisos como USUARIO</li>
                    <li>
                      (c) si se incurriera a criterio de POPNEST en conductas o actos dolosos o
                      fraudulentos
                    </li>
                    <li>
                      (d) no pudiera verificarse la identidad del USUARIO o cualquier información
                      proporcionada por el mismo fuere errónea
                    </li>
                    <li>
                      (e) POPNEST entendiera que las publicaciones u otras acciones pueden ser causa
                      de responsabilidad para el USUARIO que las publicó
                    </li>
                  </ul>
                </div>

                <p>
                  POPNEST se reserva el derecho de retirar todos aquellos comentarios y aportaciones
                  que vulneren la ley, el respeto a la dignidad de la persona, que sean
                  discriminatorios, y/o atenten contra los derechos de tercero o el orden público, o
                  bien, que a su juicio no resulten adecuados para su publicación.
                </p>

                <p>
                  En cualquier caso, POPNEST no será responsable de las opiniones vertidas por los
                  USUARIOS a través de comentarios o publicaciones que estos realicen.
                </p>

                <p>
                  El sólo acceso al SITIO WEB no supone el establecimiento de ningún tipo de
                  relación entre POPNEST y el USUARIO.
                </p>

                <p>
                  Al tratarse de un SITIO WEB dirigido exclusivamente a personas que cuenten con la
                  mayoría de edad, el USUARIO manifiesta ser mayor de edad y disponer de la
                  capacidad jurídica necesaria para sujetarse a los presentes TÉRMINOS Y
                  CONDICIONES.
                </p>
              </div>

              <div class="section">
                <h2>III. DEL ACCESO Y NAVEGACIÓN EN EL SITIO WEB</h2>
                <p>
                  POPNEST no garantiza de ningún modo la continuidad y disponibilidad de los
                  contenidos, productos o servicios ofrecidos a través del SITIO WEB, no obstante,
                  POPNEST llevará a cabo las acciones que de acuerdo con sus posibilidades le
                  permitan mantener el buen funcionamiento del SITIO WEB, sin que esto suponga
                  alguna responsabilidad de parte de POPNEST
                </p>

                <p>
                  De igual forma POPNEST no será responsable ni garantiza que el contenido o
                  software al que pueda accederse a través del SITIO WEB se encuentre libre de
                  errores, software malicioso, o que pueda causar algún daño a nivel de software o
                  hardware en el equipo a través del cual el USUARIO accede al SITIO WEB.
                </p>

                <p>
                  POPNEST tampoco se hace responsable de los daños que pudiesen ocasionarse por un
                  uso inadecuado del SITIO WEB. En ningún caso POPNEST será responsable por las
                  pérdidas, daños o perjuicios de cualquier tipo que surjan por el sólo acceso o
                  utilización del SITIO WEB.
                </p>
              </div>

              <div class="section">
                <h2>IV. POLÍTICA DE PRIVACIDAD Y PROTECCIÓN DE DATOS</h2>
                <p>
                  De conformidad con lo establecido en la Ley Federal de Protección de Datos
                  Personales en Posesión de Particulares, POPNEST se compromete a adoptar las
                  medidas necesarias que estén a su alcance para asegurar la privacidad de los datos
                  personales recabados de forma que se garantice su seguridad, se evite su
                  alteración, pérdida o tratamiento no autorizado.
                </p>

                <p>
                  Además, a efecto de dar cumplimiento a lo establecido en la Ley Federal de
                  Protección de Datos Personales en Posesión de Particulares, todo dato personal que
                  sea recabado a través del SITIO WEB, será tratado de conformidad con los
                  principios de licitud, calidad, finalidad, lealtad, y responsabilidad. Todo
                  tratamiento de datos personales quedará sujeto al consentimiento de POPNEST.
                </p>

                <p>
                  En todo caso, la utilización de datos financieros o patrimoniales, requerirán de
                  autorización expresa de POPNEST (y/o sus filiales o entidades asociadas), no
                  obstante, esta podrá darse a través del propio SITIO WEB utilizando los mecanismos
                  habilitados para tal efecto, y en todo caso se dará la mayor diligencia y cuidado
                  a este tipo de datos. Lo mismo ocurrirá en el caso de datos personales sensibles,
                  considerando por estos aquellos que debido a una utilización indebida puedan dar
                  origen a discriminación o su divulgación conlleve un riesgo para POPNEST
                </p>

                <p>
                  En todo momento se procurará que los datos personales contenidos en las bases de
                  datos o archivos que en su caso se utilicen, sean pertinentes, correctos y
                  actualizados para los fines para los cuales fueron recabados.
                </p>

                <p>
                  El tratamiento de datos personales se limitará al cumplimiento de las finalidades
                  previstas en el Aviso de Privacidad el cual se encontrará disponible en la
                  siguiente dirección electrónica:{' '}
                  <a href="https://www.popnest.org/privacy-policy" target="_blank">
                    https://www.popnest.org/privacy-policy
                  </a>
                </p>

                <p>
                  El SITIO WEB podrá incluir hipervínculos o enlaces que permitan acceder a páginas
                  web de terceros distintos POPNEST De dichos sitios web dispondrán de sus propias
                  políticas de privacidad y protección de datos, por lo cual POPNEST no asume ningún
                  tipo de responsabilidad por los datos que sean facilitados por el USUARIO a través
                  de cualquier SITIO WEB distinto a POPNEST
                </p>

                <p>
                  Los datos personales recogidos durante la compra se tratarán según la Política de
                  Privacidad de POPNEST, Asimismo, POPNEST no se hace responsables por el uso de los
                  datos personales del USUARIO por parte de las compañías de paquetería y
                  plataformas de pago, ya que son entidades ajenas a POPNEST
                </p>

                <p>
                  POPNEST se reserva el derecho a modificar su Política de Privacidad, de acuerdo
                  con sus necesidades o derivado de algún cambio en la legislación. El acceso o
                  utilización del SITIO WEB después de dichos cambios, implicará la aceptación de
                  estos cambios.
                </p>

                <p>
                  Por otra parte, el acceso al SITIO WEB puede implicar la utilización de cookies,
                  las cuales, son pequeñas cantidades de información que se almacenan en el
                  navegador utilizado por el USUARIO. Las cookies facilitan la navegación, la hacen
                  más amigable, y no dañan el dispositivo de navegación, para ello, pueden recabar
                  información para ingresar al SITIO WEB, almacenar las preferencias del USUARIO,
                  así como la interacción que este tenga con el SITIO WEB, como por ejemplo: la
                  fecha y hora en la que se accede al SITIO WEB, el tiempo que se ha hecho uso de
                  este, los sitios visitados antes y después del mismo, el número de páginas
                  visitadas, la dirección IP de la cual accede el USUARIO, la frecuencia de visitas,
                  etc.
                </p>

                <p>
                  Este tipo de información será utilizada para mejorar el SITIO WEB, detectar
                  errores, y posibles necesidades que el USUARIO pueda tener, lo anterior a efecto
                  de ofrecer a los USUARIOS servicios y contenidos de mejor calidad. En todo caso,
                  la información que se recopile será anónima y no se identificará a USUARIOS
                  individuales.
                </p>

                <p>
                  En caso de que el USUARIO no desee que se recopile este tipo de información deberá
                  deshabilitar, rechazar, restringir y/o eliminar el uso de cookies en su navegador
                  de internet. Los procedimientos para realizar estas acciones pueden diferir de un
                  navegador a otro; en consecuencia, se sugiere revisar las instrucciones
                  facilitadas por el desarrollador del navegador. En el supuesto de que rechace el
                  uso de cookies (total o parcialmente) el USUARIO podrá continuar haciendo uso del
                  SITIO WEB, aunque podrían quedar deshabilitadas algunas de las funciones de este.
                </p>

                <p>
                  Es posible que en el futuro estas políticas respecto a las cookies cambien o se
                  actualicen, por ello es recomendable revisar las actualizaciones que se realicen a
                  los presentes TÉRMINOS Y CONDICIONES, con objetivo de estar adecuadamente
                  informado sobre cómo y para qué utilizamos las cookies que se generan al ingresar
                  o hacer uso del SITIO WEB.
                </p>
              </div>

              <div class="section">
                <h2>V. POLÍTICA DE ENLACES</h2>
                <p>
                  El SITIO WEB puede contener enlaces, contenidos, servicios o funciones, de otros
                  sitios de internet pertenecientes y/o gestionados por terceros, como por ejemplo
                  imágenes, videos, comentarios, motores de búsqueda, etc.
                </p>

                <p>
                  La utilización de estos enlaces, contenidos, servicios o funciones tiene por
                  objeto mejorar la experiencia del USUARIO al hacer uso del SITIO WEB, sin que
                  pueda considerarse una sugerencia, recomendación o invitación para hacer uso de
                  sitios externos. POPNEST en ningún caso revisará o controlará el contenido de los
                  sitios externos, de igual forma, no hace propios los productos, servicios,
                  contenidos, y cualquier otro material existente en los referidos sitios enlazados;
                  por lo cual, tampoco se garantizará la disponibilidad, exactitud, veracidad,
                  validez o legalidad de los sitios externos a los que se pueda tener acceso a
                  través del SITIO WEB. Así mismo, POPNEST no asume ninguna responsabilidad por los
                  daños y perjuicios que pudieran producirse por el acceso o uso, de los contenidos,
                  productos o servicios disponibles en los sitios web no gestionados POPNEST a los
                  que se pueda acceder mediante el SITIO WEB.
                </p>

                <p>
                  Los USUARIOS o terceros que realicen o publiquen un enlace web desde una página
                  web externa, a este SITIO WEB deberán tomar en cuenta lo siguiente:
                </p>

                <p>
                  No se permite la reproducción (total o parcial) de los contenidos, productos o
                  servicios disponibles en el SITIO WEB sin la autorización expresa de POPNEST
                  Tampoco se permitirán manifestaciones falsas, inexactas o incorrectas sobre el
                  SITIO WEB, ni sobre sus contenidos, productos o servicios, pudiendo POPNEST
                  restringir el acceso al SITIO WEB a toda aquella persona que incurra en este tipo
                  de actos.
                </p>

                <p>
                  El establecimiento de un enlace al SITIO WEB desde cualquier sitio externo, no
                  implicará la existencia de alguna relación entre POPNEST y del SITIO WEB desde el
                  cual se realice, tampoco implica el conocimiento de POPNEST sobre los contenidos,
                  productos o servicios ofrecidos en los sitios externos desde los cuales se pueda
                  acceder al SITIO WEB.
                </p>
              </div>

              <div class="section">
                <h2>VI. POLÍTICA EN MATERIA DE PROPIEDAD INTELECTUAL E INDUSTRIAL</h2>
                <p>
                  POPNEST por sí o como parte cesionaria, es titular de todos los derechos de
                  propiedad intelectual e industrial del SITIO WEB, entendiendo por éste el código
                  fuente que hace posible su funcionamiento, así como las imágenes, archivos de
                  audio o video, estructuras, diseños y demás elementos que lo distinguen. Serán,
                  por consiguiente, protegidas por la legislación mexicana en materia de propiedad
                  intelectual e industrial, así como por los tratados internacionales aplicables.
                  Por consiguiente, queda expresamente prohibida la reproducción, distribución, o
                  difusión de los contenidos del SITIO WEB, con fines comerciales, en cualquier
                  soporte y por cualquier medio, sin la autorización de POPNEST
                </p>

                <p>
                  El USUARIO se compromete a respetar los derechos de propiedad intelectual e
                  industrial de POPNEST, no obstante, además de poder visualizar los elementos del
                  SITIO WEB podrá imprimirlos, copiarlos o almacenarlos, siempre y cuando sea
                  exclusivamente para su uso estrictamente personal.
                </p>

                <p>
                  Por otro lado, el USUARIO, se abstendrá de suprimir, alterar, o manipular
                  cualquier elemento, archivo, o contenido, del SITIO WEB, y por ningún motivo
                  realizará actos tendientes a vulnerar la seguridad, los archivos o bases de datos
                  que se encuentren protegidos, ya sea a través de un acceso restringido mediante un
                  USUARIO y contraseña, o porque no cuente con los permisos para visualizarlos,
                  editarlos o manipularlos.
                </p>

                <p>
                  En caso de que el USUARIO o algún tercero consideren que cualquiera de los
                  contenidos del SITIO WEB suponga una violación de los derechos de protección de la
                  propiedad industrial o intelectual, deberá comunicarlo inmediatamente a través de
                  los datos de contacto disponibles en el propio SITIO WEB.
                </p>
              </div>

              <div class="section">
                <h2>VII. COMUNICADOS ELECTRÓNICOS</h2>
                <p>
                  El USUARIO acepta recibir comunicados electrónicos a través de WhatsApp, e-mail y
                  mensajería instantánea a través del SITIO WEB por parte de POPNEST. Los avisos se
                  divulgarán a través de: correo electrónico; WhatsApp y por medio de colocar avisos
                  en la Página Web.
                </p>
                <p>
                  El USUARIO acepta que las divulgaciones que sean enviadas mediante correo
                  electrónico satisfacen los requerimientos legales.
                </p>
              </div>

              <div class="section">
                <h2>VIII. PROMOCIONES ESPECIALES</h2>
                <p>
                  POPNEST podrá lanzar promociones especiales mediante las cuales se podrán ofrecer
                  distintos beneficios a sus USUARIOS. La participación y aceptación de estas
                  promociones corresponderá a criterios determinados exclusivamente por nosotros. En
                  ningún momento POPNEST se compromete a lanzar promociones especiales en fechas
                  específicas o derivadas de alguna eventualidad.
                </p>

                <p>
                  Los términos y condiciones de las promociones especiales que POPNEST ofrezca se
                  comunicarán cuando se publique la promoción, su vigencia, y se sujetarán a los
                  presentes términos y condiciones y a las leyes mexicanas aplicables en la materia.
                </p>
              </div>

              <div class="section">
                <h2>IX. CONSENTIMIENTO</h2>
                <p>
                  Manifiesta el USUARIO que la relación contractual que se puede llegar a generar
                  por el uso de la Página o cualquiera de los Productos ofrecidos será directamente
                  con POPNEST y consistirá en una prestación de servicios celebrada por medios
                  electrónicos, en la cual el Cliente es el acreditado y POPNEST es el acreditante.
                </p>

                <p>
                  En virtud de las condiciones de capacidad legal establecidas en la legislación
                  mexicana vigente y de la validez de la manifestación expresa de voluntad, a través
                  de medios electrónicos establecida en los artículos 89 y 90 del Código de
                  Comercio, como USUARIO al momento de la creación de tu Cuenta, manifiestas
                  expresamente tu consentimiento y contar con la capacidad suficiente para celebrar
                  contratos que se pueden o pudieren llegar a realizar accediendo y usando la Página
                  o los Productos de POPNEST En este sentido, la aceptación de los presentes
                  Términos y Condiciones, así como de los contratos de adhesión respectivos de cada
                  Producto, es el medio por el que manifiestas el consentimiento expreso de
                  someterse a los mismos.
                </p>

                <p>
                  Adicionalmente, el USUARIO acepta y reconoce que la manifestación del
                  consentimiento respecto de los Servicios contratados a través del SITIO WEB, así
                  como las autorizaciones a POPNEST necesarias para su contratación, podrán ser
                  mediante medios electrónicos tales como llamada telefónica, WhatsApp, o correo
                  electrónico.
                </p>
              </div>

              <div class="section">
                <h2>X. DE LA RESERVACIÓN Y DISPONIBILIDAD DE ESPACIOS</h2>
                <p>
                  El USUARIO podrá efectuar la reservación de conformidad con la disponibilidad del
                  espacio y las condiciones establecidas que incluyen tanto el máximo de personas a
                  ingresar y el mínimo de contratación de horas o días.
                </p>

                <p>
                  POPNEST a través de su SITIO WEB oferta una variedad de espacios brindando
                  información sobre su ubicación, ofreciendo imágenes que contienen una
                  representación visual de cada inmueble, aunque se destaca que dichas imágenes
                  pueden presentar variaciones en cuanto color e iluminación pueden variar en cuanto
                  a color o iluminación.
                </p>

                <p>
                  La información detallada del inmueble se proporciona una vez que el USUARIO
                  manifiesta el interés de reservar o de realizar el pago correspondiente. De esta
                  manera se obtiene acceso a detalles específicos sobre el espacio, tales como
                  características destacadas, amenidades y cualquier información relevante para su
                  estancia. Lo cual optimiza la experiencia del USUARIO para tomar una decisión
                  informada, lo que garantiza que la información proporcionada por POPNEST sea
                  actualizada, proporcionando confianza al USUARIO al momento de realizar su
                  reserva.
                </p>

                <p>
                  POPNEST garantiza una experiencia de reserva transparente al brindar información
                  completa, real sobre las condiciones y restricciones a cada espacio, permitiendo
                  al USUARIO tomar decisiones informadas al momento de realizar su reserva.
                </p>
              </div>

              <div class="section">
                <h2>XI. DEL CAMBIO DE LA RESERVACIÓN</h2>
                <p>
                  El USUARIO tiene la posibilidad de cambiar su reserva una vez que se refleje el
                  pago total correspondiente, por un espacio de igual o superior precio, siempre y
                  cuando realice la solicitud de cambio con al menos 15 días naturales de antelación
                  a la fecha de la reserva. Así mismo, cualquier cambio estará sujeto a la
                  disponibilidad existente en ese momento.
                </p>

                <p>
                  El USUARIO se compromete a pagar cualquier cantidad adicional, comisión o impuesto
                  que esté vinculado con la modificación.
                </p>
              </div>

              <div class="section">
                <h2>XII. DE LA MODIFICACIÓN DE LA RESERVACIÓN</h2>
                <p>
                  El USUARIO podrá llevar a cabo la modificación de su itinerario para extender la
                  duración de estancia en el mismo espacio o modificar la fecha de entrada, una vez
                  que se refleje el pago total correspondiente, siempre y cuando dicha solicitud se
                  realice con al menos 15 días naturales de anticipación a la fecha de la reserva.
                  Dicha modificación estará sujeta a la disponibilidad de fechas del espacio.
                </p>

                <p>
                  Si el USUARIO desea extender la duración de su estancia y añadir horas o días a su
                  reserva existente, debe ponerse en contacto con POPNEST durante su estancia. De
                  este modo, se facilitará el proceso para llevar a cabo el pago correspondiente y
                  garantizar la continuidad de la reserva, lo cual estará sujeto a la disponibilidad
                  del espacio. Asimismo, el USUARIO se compromete a pagar cualquier cantidad
                  adicional, comisión o impuesto que esté vinculado con la modificación.
                </p>

                <p>
                  En caso de que el USUARIO, requiera prolongar su estancia después de haber
                  concluido su reserva inicial, deberá realizar una nueva reserva.
                </p>

                <p>
                  POPNEST proporciona flexibilidad al USUARIO durante su estancia, por lo que podrá
                  realizar modificaciones o ajustes en las reservas de conformidad con la
                  disponibilidad y políticas establecidas.
                </p>
              </div>

              <div class="section">
                <h2>XIII. DE LA CANCELACIÓN Y DEVOLUCIÓN DE LA RESERVACIÓN</h2>
                <p>
                  El USUARIO, podrá llevar a cabo la cancelación de su reservación una vez que se
                  refleje el pago total correspondiente y recibirá el reembolso de conformidad con
                  lo siguiente:
                </p>

                <ol>
                  <li>
                    Para recibir el 90% de devolución del importe pagado por concepto de reservación
                    de algún espacio, el USUARIO deberá cancelar con 30 días naturales de
                    anticipación a la fecha de inicio del alojamiento.
                  </li>
                  <li>
                    Para recibir el 70% de devolución del importe pagado por concepto de reservación
                    de algún espacio, el USUARIO deberá realizar la cancelación con una antelación
                    de 29 a 15 días naturales previos a la fecha programada para el inicio del
                    alojamiento.
                  </li>
                  <li>
                    Para recibir el 50% de devolución del importe pagado por concepto de reservación
                    de espacio, el USUARIO deberá realizar la cancelación con una antelación de 14 a
                    10 días naturales previos a la fecha programada para el inicio del alojamiento.
                  </li>
                  <li>
                    La política de reembolso quedará sin efecto si el USUARIO solicita la
                    cancelación dentro de un plazo de 9 días naturales y hasta 24 horas antes de la
                    fecha de inicio del alojamiento.
                  </li>
                </ol>

                <table>
                  <thead>
                    <tr>
                      <th>DÍAS DE ANTICIPACIÓN A LA FECHA DE RESERVA</th>
                      <th>PORCENTAJE DE DEVOLUCIÓN</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Hasta 30 días naturales</td>
                      <td>90%</td>
                    </tr>
                    <tr>
                      <td>De 29 a 15 días naturales</td>
                      <td>70%</td>
                    </tr>
                    <tr>
                      <td>De 14 a 10 días naturales</td>
                      <td>50%</td>
                    </tr>
                    <tr>
                      <td>9 días naturales o menos</td>
                      <td>No aplica reembolso</td>
                    </tr>
                  </tbody>
                </table>

                <p>
                  Se entiende por "día 0", el día en el que el USUARIO hace uso del espacio. Y se
                  entiende por "día 1", al día previo al inicio del alojamiento.
                </p>

                <p>
                  En caso de que la estancia no se pudiere llevar a cabo por circunstancias de
                  fuerza mayor o caso fortuito, el USUARIO cuenta con diversas opciones para
                  gestionar su reserva. (i) El USUARIO podrá optar por solicitar el reembolso del
                  monto correspondiente, (ii) reprogramar la estancia para otra fecha siempre y
                  cuando se tome en consideración la disponibilidad del espacio y (iii) podrá
                  realizar el cambio de la reserva por otro espacio del mismo costo.
                </p>

                <p>
                  POPNEST se compromete a ofrecer flexibilidad en caso de que la reprogramación o el
                  cambio de espacio resulten viables, garantizando una experiencia de reserva que se
                  ajuste a las preferencias y necesidades del USUARIO.
                </p>
              </div>

              <div class="section">
                <h2>XIV. DE LA POLÍTICA DE RESPONSABILIDAD DEL USUARIO</h2>
                <p>
                  El USUARIO asume la responsabilidad de sus acciones y omisiones dentro del
                  espacio, proporcionado por el Anfitrión. Por lo que el USUARIO:
                </p>
                <ul>
                  <li>(i) deberá ocupar y desocupar el espacio en el horario convenido</li>
                  <li>
                    (ii) tiene la responsabilidad de dejar el espacio en el mismo estado en que se
                    encontraba al momento de su llegada
                  </li>
                  <li>
                    (iii) es responsabilidad del USUARIO, cubrir los montos de reclamación por daños
                    para compensar los perjuicios causados por el USUARIO, huéspedes o mascotas a un
                    espacio
                  </li>
                  <li>
                    (iv) el USUARIO está obligado a mantener un comportamiento con integridad,
                    cumpliendo con las leyes aplicables en todo momento
                  </li>
                </ul>
              </div>

              <div class="section">
                <h2>XV. DEL PAGO</h2>
                <p>
                  El SITIO WEB utiliza un sistema de cobro operado por STRIPE Payments en el cual el
                  USUARIO puede escoger entre los siguientes métodos de pago el que le resulte más
                  conveniente:
                </p>
                <ul>
                  <li>(i) ApplePay</li>
                  <li>(ii) Oxxo (por medio de una referencia de pago)</li>
                  <li>
                    (iii) Tarjeta débito y crédito con procesadores de pago Visa, MasterCard y
                    American Express
                  </li>
                </ul>
              </div>

              <div class="section">
                <h2>XVI. DE LAS DUDAS, RECLAMACIONES O ACLARACIONES</h2>
                <p>
                  El USUARIO puede emitir dudas, reclamaciones o aclaraciones a POPNEST a través del
                  correo electrónico: <a href="mailto:info@popnest.org">info@popnest.org</a>
                </p>
              </div>

              <div class="section">
                <h2>XVII. DE LA ATENCIÓN AL CLIENTE</h2>
                <p>
                  POPNEST pone a disposición del USUARIO el correo electrónico{' '}
                  <a href="mailto:info@popnest.org">info@popnest.org</a> medio a través del cual
                  puede comunicarse con el área de Atención a Clientes, en el cual se puede resolver
                  cualquier cuestión relativa al uso del SITIO WEB o la compra de productos.
                </p>
              </div>

              <div class="section">
                <h2>XVIII. DE LOS DAÑOS</h2>
                <p>
                  POPNEST no es responsable sobre cualquier daño que se ocasione en el espacio
                  contratado por el USUARIO. El USUARIO asume toda la responsabilidad por el uso del
                  espacio contratado, incluyendo la conservación adecuada de las instalaciones, la
                  seguridad de los objetos personales y la conducta general durante su estancia, el
                  USUARIO exime a POPNEST de cualquier responsabilidad relacionada con incidentes o
                  accidentes que puedan surgir durante el periodo de utilización del espacio
                  contratado
                </p>

                <p>
                  Los acuerdos pactados entre el USUARIO y el Anfitrión se desarrollan de manera
                  independiente a la participación de POPNEST. Por lo que POPNEST no asume
                  responsabilidad por posibles incumplimientos en los acuerdos establecidos entre el
                  USUARIO y el Anfitrión; cualquier disputa o desacuerdo derivado de dicha
                  interacción no involucra a POPNEST.
                </p>
              </div>

              <div class="section">
                <h2>XIX. DE LA LEGISLACIÓN Y JURISDICCIÓN APLICABLE</h2>
                <p>
                  POPNEST se reserva la facultad de todas las acciones, y/o derechos que considere
                  necesarias, en contra del USUARIO por la utilización indebida del SITIO WEB, sus
                  contenidos, productos o servicios, o por el incumplimiento de los presentes
                  TÉRMINOS Y CONDICIONES.
                </p>

                <p>
                  La relación entre el USUARIO y POPNEST se regirá por la legislación vigente en
                  México, específicamente en la Ciudad de México. De surgir controversias
                  relacionadas con la interpretación y/o a la aplicación de los presentes TÉRMINOS Y
                  CONDICIONES, las partes se someterán a la jurisdicción ordinaria de los tribunales
                  correspondientes conforme a derecho en el estado referido.
                </p>
              </div>

              <div class="contact-info">
                <h4>Contacto</h4>
                <p>
                  <strong>POPNEST</strong>
                </p>
                <p>
                  <strong>FINOVIX, S.A.P.I. de C.V.</strong>
                </p>
                <p>Domicilio: COYOACÁN, ÁLVARO OBREGÓN</p>
                <p>
                  Email: <a href="mailto:info@popnest.org">info@popnest.org</a>
                </p>
                <p>
                  Sitio web:{' '}
                  <a href="https://popnest.org" target="_blank">
                    popnest.org
                  </a>
                </p>
              </div>
            </div>

            <footer>
              <p class="contact-info">Dudas o aclaraciones: info@popnest.org</p>
            </footer>
          </>
        )}
      </Label>
    </FlexContainer>
  );
};

export default TermsAndConditions;
